import { Alert } from 'react-bootstrap';
import styled from 'styled-components';

import { min } from '../../utils/breakpoints';

const StyledAlert = styled(Alert)`
  border-radius: 0;
  margin: 0;
  text-align: center;
  cursor: pointer;
  pointer-events: auto;
  display: flex;
  padding: 0;
`;

const StyledImage = styled.img`
  margin-top: -2px;
  width: ${({ iconSize }) => (iconSize ? `${iconSize}px` : 'auto')};
  height: ${({ iconSize }) => (iconSize ? `${iconSize}px` : 'auto')};
`;

const StyledDivBefore = styled.div`
  flex-grow: 1;
  background: url(${({ beforeBg }) => beforeBg}) right center no-repeat;

  ${min.xxl} {
    background-position: left center;
  }
`;

const StyledDivAfter = styled.div`
  flex-grow: 1;
  background: url(${({ afterBg }) => afterBg}) left center no-repeat;

  ${min.xxl} {
    background-position: right center;
  }
`;

const StyledContentDiv = styled.div`
  gap: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 28px 11px;
`;

/**
 * @typedef {Object} AlertBarProps
 * @property {import('react').ReactNode} label
 * @property {string} icon
 * @property {() => void} onClick
 * @property {string} variant
 * @property {string | null | undefined} [afterIcon]
 * @property {string | null | undefined} [beforeBg]
 * @property {string | null | undefined} [afterBg]
 * @property {number} [iconSize]
 */

/**
 * @param {AlertBarProps} props
 */
const AlertBar = (props) => {
  const { label, icon, onClick, variant, afterIcon = null, beforeBg = null, afterBg = null, iconSize } = props;

  return (
    <StyledAlert onClick={onClick} variant={variant}>
      <StyledDivBefore beforeBg={beforeBg} />
      <StyledContentDiv>
        <StyledImage src={icon} alt="Image before the label" iconSize={iconSize} /> {label}
        {!!afterIcon && <StyledImage src={afterIcon} alt="Image after the label" iconSize={iconSize} />}
      </StyledContentDiv>
      <StyledDivAfter afterBg={afterBg} />
    </StyledAlert>
  );
};

export default AlertBar;
